import { useRef, useEffect } from 'react';

function useSlider(isMobile, itemSelector = 'li',) {

    const sliderRef = useRef(null);
    const currentIndex = useRef(0);
    const autoSlideTimer = useRef(null);


    // 자동 슬라이드 함수
    const startAutoSlide = () => {
        stopAutoSlide();
        autoSlideTimer.current = setInterval(() => {
            moveTo(currentIndex.current + 1);
        }, 2500); // 1.5초마다 이동
    };

    const stopAutoSlide = () => {
        if (autoSlideTimer.current) clearInterval(autoSlideTimer.current);
    };

    // 슬라이드 이동 함수
    const moveTo = (idx) => {
        const slider = sliderRef.current;
        if (!slider) return;
        const items = slider.querySelectorAll('.mobile-section li');
        const total = items.length;
        let newIdx = idx;
        if (newIdx < 0) newIdx = total - 1;
        if (newIdx >= total) newIdx = 0;
        currentIndex.current = newIdx;
        const itemWidth = items[0].offsetWidth;
        slider.scrollTo({
            left: itemWidth * newIdx,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        const slider = sliderRef.current;
        if (!slider) return;

        let isDown = false;
        let startX, scrollLeft;

        // 마우스/터치 이벤트 핸들러
        const onDown = (e) => {
            isDown = true;
            stopAutoSlide();
        };
        const onMove = (e) => {
            if (!isDown) return;
            stopAutoSlide();
        };
        const onUp = (e) => {
            if (!isDown) return;
            isDown = false;
            // 가장 가까운 li로 정렬
            const items = slider.querySelectorAll('li');
            const itemWidth = items[0].offsetWidth;
            const idx = Math.round(slider.scrollLeft / itemWidth);
            moveTo(idx);
            setInterval(() => {
                startAutoSlide();
            }, 2500); // 1.5초마다 이동

        };

        // 이벤트 등록
        // slider.addEventListener('mousedown', onDown);
        slider.addEventListener('mousemove', onMove);
        slider.addEventListener('mouseup', onUp);
        slider.addEventListener('mouseleave', onUp);

        slider.addEventListener('touchstart', onDown);
        slider.addEventListener('touchmove', onMove);
        slider.addEventListener('touchend', onUp);

        // 초기 자동 슬라이드 시작
        startAutoSlide();

        // 언마운트시 이벤트 해제
        return () => {
            stopAutoSlide();
            slider.removeEventListener('mousedown', onDown);
            slider.removeEventListener('mousemove', onMove);
            slider.removeEventListener('mouseup', onUp);
            slider.removeEventListener('mouseleave', onUp);

            slider.removeEventListener('touchstart', onDown);
            slider.removeEventListener('touchmove', onMove);
            slider.removeEventListener('touchend', onUp);
        };
    }, [isMobile, itemSelector])

    return sliderRef;
};

export default useSlider;